import React, { useState } from 'react';
import './Header.css';
import SearchIcon from '@material-ui/icons/Search';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import { Link } from 'react-router-dom';
import { useStateValue } from './StateProvider';
import { auth } from './firebase';


function Header() {
  const [{basket, user}, dispatch] = useStateValue();

  const handleAuthentication = () => {
    if (user) {
      auth.signOut();
    }
  }

  // ===== toggle menu =======
  const [clicked, setClicked] = useState(true);

  const toggleMenu = () => {
    setClicked(!clicked);
  };

  return (
    <div class="header">

      <div className="menu__icon" onClick={toggleMenu}>{ clicked? <MenuIcon/> : <CloseIcon/>}</div>

      <div className={ clicked ? "responsive__hide" : "responsive__menu" }>
        <Link to="/">
          <img className="header_logo" src={window.location.origin + '/logo-w.png'} alt="Logo"/>
        </Link>
        <div className="header_search">
          <input 
            className="header_searchInput"
            type="text" 
            placeholder="Search..."
          />
          <SearchIcon className="header_searchIcon" />
        </div>

        <Link to="/return">
          <div className="header_option">
            <span className="header_optionLineOne">returns</span>
            <span className="header_optionLineTwo">orders</span>
          </div>
          </Link>

      </div>
      

      <div className="header_nav">
        <Link to={!user && '/login'}>
        <div onClick={handleAuthentication} className="header_option">
          <span className="header_optionLineOne">Hello, {user?.email}</span>
          <span className="header_optionLineTwo">{user ? 'Sign Out' : 'Sign In'}</span>
        </div>
        </Link>

        <Link to="/checkout">
          <div className="header_optionBasket">
            <ShoppingBasketIcon />
            <span className="header_optionLineTwo header_basketCount">{basket?.length}</span>
          </div>
        </Link>
      </div>
    </div>
  )
}

export default Header;
